<template>
	<div
		class="time-ticket-week-circle"
		:class="value > 0 ? `time-ticket-week-circle--${color}` : null">
		<div class="time-ticket-week-circle__circle">
			{{ value }}
		</div>
		<div class="time-ticket-week-circle__label">
			{{ label }}
		</div>
	</div>
</template>

<script setup lang="ts">
import TimeTicketWeekCircleSetupService from '@/setup/time-ticket/TimeTicketWeekCircleSetupService';
const props = defineProps(TimeTicketWeekCircleSetupService.props);
const setup = new TimeTicketWeekCircleSetupService(props);
</script>

<style scoped lang="less">
@import '@/styles/variables';
@import '@/styles/mixins';
  .time-ticket-week-circle {
    display: flex;
    align-items: center;

    &__circle {
      .circle(40px);
      .flex-align();
      font-size: 18px;
      font-weight: 600;
      border-width: 2px;
      border-style: solid;
      border-color: var(--grey-light);
      color: var(--grey);
    }

    &__label {
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 15px;
      margin-left: 10px;
    }

    each(@circleColors, {
			@color: ~"--@{value}";
      &--@{value} .time-ticket-week-circle__circle {
        border-color: var(@color);
        color: var(@color);
      }
    });
  }
</style>
